import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './utils/segmentInit';
import App from './App';

// Global styles
import './styles/tokens.css';
import './styles/global.css';
import './styles/animations.css';

// Component styles - page layouts
import './styles/components/auth.css';
import './styles/components/loading.css';
import './styles/components/express.css';
import './styles/components/quiz-layout.css';
import './styles/components/results.css';
import './styles/components/blueprint.css';
import './styles/components/plan.css';
import './styles/components/activate.css';
import './styles/components/rental.css';
import './styles/components/taxes.css';
import './styles/components/sequence-quiz.css';
import './styles/components/adhd-quiz.css';

// UI component styles
import './components/ui/button.css';
import './components/ui/card.css';
import './components/ui/input.css';
import './components/ui/textarea.css';
import './components/ui/select.css';
import './components/ui/dropdown.css';
import './components/ui/checkbox.css';
import './components/ui/progressbar.css';
import './components/ui/autocomplete.css';

// Feature component styles
import './components/express/animated-placeholder.css';
import './components/express/example-chips.css';
import './components/express/quick-profile.css';
import './components/quiz/testimonial-carousel.css';
import './components/shared/trust-badges.css';

// Page-specific styles
import './pages/quiz/steps/value-prop.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
